import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import { PRICING_PROFILE_DATE_RANGE_COLUMNS } from '../../../../config/dynamicFormFields';
import { isRequired, validateNumber } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';

const validateFields = (values) => {
  const errors = {};

  if (
    !values.pricingProfileDateRangeList ||
    !values.pricingProfileDateRangeList.length
  ) {
    errors.pricingProfileDateRangeError = 'Debe ingresar una fecha';
  }

  return errors;
};

export const NewPricingProfileDateRangeForm = ({ handleSubmit, loading }) => {
  const renderDynamicForm = () => (
    <DynamicForm
      name="pricingProfileDateRangeList"
      columns={PRICING_PROFILE_DATE_RANGE_COLUMNS}
    />
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup row>
          <FormItem label="Año">
            <Field
              name="year"
              component={TextInput}
              validate={[isRequired, validateNumber]}
            />
          </FormItem>
        </FormGroup>
        <Field
          name="pricingProfileDateRangeError"
          component={TextInput}
          type="hidden"
        />
        {renderDynamicForm()}
        <FormFooter
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
        />
      </Form>
    </>
  );
};

NewPricingProfileDateRangeForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
};

NewPricingProfileDateRangeForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'NewPricingProfileDateRangeForm',
  validate: validateFields,
})(NewPricingProfileDateRangeForm);

export default connect(mapStateToProps, null)(formComponent);
